import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteProvider } from "./context/SiteContext";
import { Layout } from "./components/site/Layout";
import Home from "./pages/Home";
import SeoPage from "./pages/SeoPage";
import ServiceDetail from "./pages/ServiceDetail";
import GalleryPage from "./pages/GalleryPage";
import ReviewsPage from "./pages/ReviewsPage";
import GiftPage from "./pages/GiftPage";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";

const AdminApp = lazy(() => import("./pages/admin/AdminApp"));

const SEO_KEYS = ["sivas-masaj-salonu", "sivas-masaj", "sivas-spa", "sivas-spa-merkezi", "masaj-hizmetleri", "hakkimizda"];

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              {SEO_KEYS.map((k) => (
                <Route key={k} path={`/${k}`} element={<SeoPage key={k} pageKey={k} />} />
              ))}
              <Route path="/hizmet/:slug" element={<ServiceDetail />} />
              <Route path="/galeri" element={<GalleryPage />} />
              <Route path="/yorumlar" element={<ReviewsPage />} />
              <Route path="/hediye-ceki" element={<GiftPage />} />
              <Route path="/iletisim" element={<ContactPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route
              path="/admin/*"
              element={
                <Suspense fallback={<div className="min-h-screen bg-cream" />}>
                  <AdminApp />
                </Suspense>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SiteProvider>
    </div>
  );
}

export default App;
